import { Outlet } from "react-router-dom";

import AuthNavbar from "./AuthNavbar";

import ORLogo from "@/assets/OR_new_logo.png";
import ORLogoLight from "@/assets/OR_new_logo_light.png";
import { AuroraBackground } from "@/components/ui/v2/aurora-background";
import { ShootingStars } from "@/components/ui/v2/shooting-stars";
import { StarsBackground } from "@/components/ui/v2/stars-background";
import { ThemeBackdrop } from "@/themes/theme-backdrop";

function AuthLayout() {
  return (
    <div data-slot="auth-layout" className="relative flex flex-col items-center justify-center min-h-screen bg-background-alt">
      <div data-slot="auth-base-backdrop" className="absolute inset-0 dark:hidden">
        <AuroraBackground />
      </div>
      <div data-slot="auth-base-backdrop" className="absolute inset-0 hidden dark:block">
        <ShootingStars />
        <StarsBackground />
      </div>
      <ThemeBackdrop slot="auth" />
      <nav className="absolute top-0 right-0 p-4 z-10">
        <AuthNavbar />
      </nav>
      <div className="relative z-10 flex flex-col items-center justify-center gap-32 w-full">
        <img src={ORLogoLight} alt="Brand Logo" className="w-[246px] h-14 dark:hidden" />
        <img src={ORLogo} alt="Brand Logo" className="hidden dark:block w-[246px] h-14" />
        <div className="flex justify-center w-full">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default AuthLayout;
